namespace app.support{
    export class StfToggleButtonController{
        public a = "false";
        public value: any
        public config: StfToggleButtonConfig
        public fieldId: string
        public required: boolean
        public disabled: boolean
        public autoFocus: boolean
        public listValue: any
        public listItems: any[]
        public selectedListItem: any
        public onValueChange: Function
        public btnOutrosSelecionado: boolean = false
        public btnOutrosPrimeiroAcesso:boolean = true

        /** @ngInject */
        constructor(private $scope: StfToggleButtonScope){
            this.value = this.$scope.value
            this.listValue = this.value;
            this.config = this.$scope.config;
            this.fieldId = this.$scope.fieldId
            this.required = this.$scope.required !== null && this.$scope.required !== undefined && this.$scope.required !== 'false'
            this.disabled = this.$scope.disabled
            this.onValueChange = this.$scope.onValueChange
            this.autoFocus = this.$scope.autoFocus !== null && this.$scope.autoFocus !== undefined && this.$scope.autoFocus !== 'false'

            this.disableButtonByValue()
            this.setAutoFocus()
            this.listItems = this.config.list;
            this.selectedListItem = this.config.selectedListIndex
        }

        public buttonClick(evt: UIEvent, id: string): void{
            if(this.disabled){
                return
            }

            this.changeValueById(id)
        }
        
        public changeValueById(id: string): void{
            if (id === "btnOutros") {
                this.btnOutrosSelecionado = !this.btnOutrosSelecionado;
                if(this.btnOutrosPrimeiroAcesso && !!this.selectedListItem){
                    this.listValue = this.selectedListItem;
                    this.$scope.value = this.selectedListItem;
                    this.btnOutrosPrimeiroAcesso = false;
                }
                else if(!!this.listValue){
                    this.$scope.value = this.listValue;
                }
                    
                
                
            } else {
                if(!this.config.buttons.find(b => b.id === id)) throw new Error("Não existe um botão com o id especificado")
            }

            for(var i = 0 ; i < this.config.buttons.length ; i++){
                let btn = this.config.buttons[i]
                if(btn.id === id){
                    btn.disabled = ! btn.disabled
                    this.btnOutrosSelecionado = false
                    this.$scope.value = btn.disabled ? btn.value : null
                }
                else {
                    btn.disabled = false
                }
            }

        }

        public disableButtonByValue(value = this.value): void{
            this.enableAllButtons()

            if (!value) {
                return
            }

            const btn = this.config.buttons.find(btn => btn.value === value)
            if (btn) {
                btn.disabled = true
            } else {
                this.listValue = value;
                this.changeValueByListItem();
            }
        }

        public changeValueByListItem(): void {
            this.$scope.value = this.listValue
            this.enableAllButtons()
        }

        public updateListItems(): void{
            if (!this.config.list) return

            this.listValue = null
            this.btnOutrosSelecionado = false
            if(!this.$scope.value) this.enableAllButtons()

            this.listItems = this.config.list.filter(item => {
                return ! this.config.buttons.find(btn => { 
                    return btn.value.toString().toLowerCase() === item.id.toString().toLowerCase()
                })
            })

            this.selecionarValorDaListaBotaoOutros();
        }

        private selecionarValorDaListaBotaoOutros(): void {
            let selectedValueBtn = this.config.buttons.find(btn => btn.value === this.value);
            if ((!!this.listItems && this.listItems.length > 0)
                    && !!this.value && selectedValueBtn === undefined) {
                
                let listItemsValue = this.listItems.find(item => item.id === this.value);
                if(!!listItemsValue) {
                    this.btnOutrosSelecionado = true;
                    this.listValue = this.value;
                }
            }
        }

        public enableAllButtons(): void {
            for(var i = 0 ; i < this.config.buttons.length ; i++) {
                this.config.buttons[i].disabled = false
            }
        }

        public setAutoFocus(): void {
            for(var i = 0 ; i < this.config.buttons.length ; i++) {
                this.config.buttons[i].focusIf = (this.autoFocus && 
                    ((i==0 && !this.config.buttons[i].disabled) || (i==1 && this.config.buttons[0].disabled)))?true:false
            }
        }        
            
    }
}